<template>
  <div class="hris-page">
    <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">Online Forms</span>
      <h1 class="hris-page-title">Work From Home</h1>
      <p class="hris-page-subtitle">Submit a work-from-home request for inclusive dates.</p>
    </div>

    <div class="hris-form-narrow">
    <q-form>
      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Inclusive Dates</h2>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <label class="hris-form-label">From</label>
            <q-input v-model="dateFromInput" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                  <q-popup-proxy ref="qDateFromProxy" transition-show="flip-down" transition-hide="flip-up">
                    <q-date v-model="form.selectedDateFrom" @input="$refs.qDateFromProxy.hide()" today-btn color="green" minimal ></q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="hris-form-field">
            <label class="hris-form-label">To</label>
            <q-input v-model="dateToInput" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                  <q-popup-proxy ref="qDateToProxy" transition-show="flip-down" transition-hide="flip-up">
                    <q-date v-model="form.selectedDateTo" @input="$refs.qDateToProxy.hide()" today-btn color="green" minimal />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </div>

      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Date of Return</h2>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <q-input v-model="dateReturnInput" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                  <q-popup-proxy ref="qDateRetProxy" transition-show="flip-down" transition-hide="flip-up">
                    <q-date v-model="form.dateReturn" @input="$refs.qDateRetProxy.hide()" today-btn color="green" minimal />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </div>

      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Reason</h2>
        <div class="hris-form-row">
          <div class="hris-form-field" style="flex-basis: 100%;">
            <q-input type="textarea" v-model="form.obtReason" outlined dense color="green" maxlength="250" clearable bottom-slots counter hint="Max 250 characters" />
          </div>
        </div>
      </div>

      <div class="hris-form-actions">
        <q-btn unelevated class="hris-q-outline" @click="resetForm" label="Reset" style="min-width: 140px;" />
        <q-btn unelevated class="hris-q-primary" @click="submitApplication" :loading="loading" label="Submit" style="min-width: 140px;">
          <template v-slot:loading>
            <q-spinner color="green" class="on-left" />
            Sending...
          </template>
        </q-btn>
      </div>
    </q-form>
    </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { date } from 'quasar';

let today = Date.now();
let dateToday = date.formatDate(today, 'YYYY/MM/DD');
const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

export default {
  name: 'OfficialBusinessTrip',
  props: ['value'],
  data() {
    return {
      loading: false,
      date: '',
      dateToday,
      form: {
        selectedDateFrom: '',
        selectedDateTo: '',
        dateReturn: '',
        obtReason: ''
      }
    }
  },
  methods: {
    startDate: function(date) {
      return date >= this.dateToday;
    },

    endDate: function(date) {
      if (this.form.selectedDateFrom == '') {
        return date >= this.dateToday;
      } else {
        return date >= this.form.selectedDateFrom;
      }
    },

    returnDate: function(date) {
      if (this.form.selectedDateTo == '') {
        return date >= this.dateToday;
      } else {
        return date >= this.form.selectedDateTo;
      }
    },

    submitApplication: function() {
      if (this.form.selectedDateFrom == undefined || this.form.selectedDateTo == undefined ||
        this.form.dateReturn == undefined || this.form.tripCovered == '' ||
        this.form.obtReason == '') {
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'Please fill-in all necessary details.'
        });
      } else if (this.form.selectedDateFrom > this.form.selectedDateTo) {
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'Please check the date. "Date From" is greater than "Date To".'
        });
      } else if (this.form.selectedDateTo > this.form.dateReturn) {
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'Please check the date. "Date To" is greater than "Date of Return".'
        });
      } else {
        this.loading = true;
        this.form.selectedDateFrom = date.formatDate(this.form.selectedDateFrom, 'YYYY-MM-DD');
        this.form.selectedDateTo = date.formatDate(this.form.selectedDateTo, 'YYYY-MM-DD');
        this.form.dateReturn = date.formatDate(this.form.dateReturn, 'YYYY-MM-DD');

        let formData = new FormData();
        formData.append('form_data', JSON.stringify(this.form));

        axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        }).post('/online-forms/applications/wfh', formData).then((res) => {
          setTimeout(() => {
            this.loading = false;
            this.$q.notify({
              color: 'green-7',
              textColor: 'white',
              icon: 'fa fa-shipping-fast',
              message: 'WFH Application Submitted!'
            });
            this.resetForm();
          }, 1000);
        });
      }
    },

    resetForm: function() {
      var self = this;
      Object.keys(this.form).forEach(function(key, index) {
        self.form[key] = '';
      });
      setTimeout(() => {
        scrollToTop();
      }, 200);
    }
  },
  computed: {
    dateFromInput: function() {
      if (this.form.selectedDateFrom == '') {
        return 'Please select a date...';
      } else {
        let d = new Date(this.form.selectedDateFrom);
        return date.formatDate(d, 'dddd, MMMM DD, YYYY');
      }
    },

    dateToInput: function() {
      if (this.form.selectedDateTo == '') {
        return 'Please select a date...';
      } else {
        let d = new Date(this.form.selectedDateTo);
        return date.formatDate(d, 'dddd, MMMM DD, YYYY');
      }
    },

    dateReturnInput: function() {
      if (this.form.dateReturn == '') {
        return 'Please select a date...';
      } else {
        let d = new Date(this.form.dateReturn);
        return date.formatDate(d, 'dddd, MMMM DD, YYYY');
      }
    }
  }
}
</script>
<style scoped>
</style>
